<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        width: {
          name: 'width',
          defaultValue: '100',
          min: '250',
          max: '1100',
          labelDesc: 'width',
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
            vm.element.internal_config.height = this.value + 'px';
          }
        },
        height: {
          name: 'height',
          defaultValue: 150,
          min: '50',
          max: '1500',
          labelDesc: 'height-content',
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.contentStyle.height = this.value + 'px';
          }
        },
        imageHeight: {
          name: 'heightContainer',
          defaultValue: 150,
          min: '50',
          max: '1500',
          labelDesc: 'height-content',
          callback: function() {
            vm.resources.imageHeight.defaultValue = this.value;
            vm.element.internal_config.imageHeight = this.value + 'px';
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          }
        },
        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          gradient: false,
          labelDesc: 'background-color',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColor = this.colorValue;
          }
        },
        colorDetails: {
          name: 'backgroundColorSelected',
          defaultValue: '#000',
          gradient: false,
          labelDesc: 'color-details',
          callback: function() {
            vm.resources.colorDetails.defaultValue = this.colorValue;
            vm.element.internal_config.colorDetails = this.colorValue;
          }
        },
        colorTexts: {
          name: 'colorHoverReadMore',
          defaultValue: '#000',
          gradient: false,
          labelDesc: 'color-texts',
          callback: function() {
            vm.resources.colorTexts.defaultValue = this.colorValue;
            vm.element.internal_config.colorTexts = this.colorValue;
          }
        },
        colorSubTexts: {
          name: 'backgroundColorContainer',
          defaultValue: '#000',
          gradient: false,
          labelDesc: 'color-sub-text',
          callback: function() {
            vm.resources.colorSubTexts.defaultValue = this.colorValue;
            vm.element.internal_config.colorSubTexts = this.colorValue;
          }
        },
        titleStyle: {
          name: 'blogTitleStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'blogTitleStyle',
          callback: function() {
            vm.resources.titleStyle.defaultFamily = this.family;
            vm.element.internal_config.titleStyle.family = this.family;

            vm.resources.titleStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.titleStyle.size = this.size + 'px';

            vm.resources.titleStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.titleStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.titleStyle.defaultColor = this.color;
            vm.element.internal_config.titleStyle.color = this.color;

            vm.resources.titleStyle.defaultAlign = this.align;
            vm.element.internal_config.titleStyle.align = this.align;

            vm.resources.titleStyle.defaultWeight = this.weight;
            vm.element.internal_config.titleStyle.weight = this.weight;

            vm.resources.titleStyle.defaultStyle = this.style;
            vm.element.internal_config.titleStyle.style = this.style;

            vm.resources.titleStyle.defaultStroke = this.stroke;
            vm.element.internal_config.titleStyle.stroke = this.stroke;
          }
        },
        contentStyle: {
          name: 'subTextContent',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultSizeMobile: '',
          shitOptions: true,
          showSizeMobile: true,
          defaultStroke: '',
          defaultAlign: '',
          labelDesc: 'subTextContent',
          callback: function() {
            vm.resources.contentStyle.defaultFamily = this.family;
            vm.element.internal_config.contentStyle.family = this.family;

            vm.resources.contentStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.contentStyle.size = this.size + 'px';

            vm.resources.contentStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.contentStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.contentStyle.defaultColor = this.color;
            vm.element.internal_config.contentStyle.color = this.color;

            vm.resources.contentStyle.defaultAlign = this.align;
            vm.element.internal_config.contentStyle.align = this.align;

            vm.resources.contentStyle.defaultWeight = this.weight;
            vm.element.internal_config.contentStyle.weight = this.weight;

            vm.resources.contentStyle.defaultStyle = this.style;
            vm.element.internal_config.contentStyle.style = this.style;

            vm.resources.contentStyle.defaultStroke = this.stroke;
            vm.element.internal_config.contentStyle.stroke = this.stroke;
          }
        },
        theme: {
          name: 'type',
          defaultValue: '',
          labelDesc: 'theme',
          options: [
            {name: '01', value: '01', selected: 'selected', disabled: false},
            {name: '02', value: '02', selected: false, disabled: false},
            {name: '03', value: '03', selected: false, disabled: false},
            {name: '04', value: '04', selected: false, disabled: false}
          ],
          callback: function() {
            vm.resources.theme.defaultValue = this.value;
            vm.element.internal_config.theme = this.value;
          }
        }
      }
    };
  },
  methods: {
    setMinValuesData(resource, value) {
      this.resources[resource].min = parseInt(value);
    },
    setValuesData(data) {
      this.element = data;
      this.resources.width.defaultValue = data.internal_config.width;
      this.resources.height.defaultValue = data.internal_config.contentStyle.height;
      this.resources.imageHeight.defaultValue = data.internal_config.imageHeight;
      this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
      this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
      this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
      this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
      this.resources.theme.defaultValue = data.internal_config.theme;

      // titleStyle
      this.resources.titleStyle.defaultFamily = data.internal_config.titleStyle.family;
      this.resources.titleStyle.defaultSize = data.internal_config.titleStyle.size;
      this.resources.titleStyle.defaultSizeMobile = data.internal_config.titleStyle.sizeMobile;
      this.resources.titleStyle.defaultColor = data.internal_config.titleStyle.color;
      this.resources.titleStyle.defaultAlign = data.internal_config.titleStyle.align;
      this.resources.titleStyle.defaultWeight = data.internal_config.titleStyle.weight;
      this.resources.titleStyle.defaultStyle = data.internal_config.titleStyle.style;
      this.resources.titleStyle.defaultStroke = data.internal_config.titleStyle.stroke;

      // contentStyle
      this.resources.contentStyle.defaultFamily = data.internal_config.contentStyle.family;
      this.resources.contentStyle.defaultSize = data.internal_config.contentStyle.size;
      this.resources.contentStyle.defaultSizeMobile = data.internal_config.contentStyle.sizeMobile;
      this.resources.contentStyle.defaultColor = data.internal_config.contentStyle.color;
      this.resources.contentStyle.defaultAlign = data.internal_config.contentStyle.align;
      this.resources.contentStyle.defaultWeight = data.internal_config.contentStyle.weight;
      this.resources.contentStyle.defaultStyle = data.internal_config.contentStyle.style;
      this.resources.contentStyle.defaultStroke = data.internal_config.contentStyle.stroke;

      // colors
      this.resources.colorDetails.defaultValue = data.internal_config.colorDetails;
      this.resources.colorTexts.defaultValue = data.internal_config.colorTexts;
      this.resources.colorSubTexts.defaultValue = data.internal_config.colorSubTexts;

      this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Generic/Resources/AppsWithArticlesResource.vue